<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>REGISTROS DE PAGAMENTOS GESCON</span>
                    <div class="float-right">
                        <span class="text-primary">
                            <i
                                class="fa fa-refresh fa-lg icon-button"
                                title="Atualizar"
                                @click.stop="$emit('atualizar-listagem')"
                            ></i>
                        </span>
                    </div>
                </h4>
                <b-alert
                    show
                    variant="warning"
                    v-if="mostrarQuadroAvisoPagamentoCriado"
                >
                    <h5>Atenção</h5>
                    <p>
                        Já existe um <strong>PROTOCOLO</strong> de registro de
                        pagamento <strong>CRIADO</strong> e
                        <strong>NÃO</strong> enviado para análise.<br />É
                        possível utiliza-lo para enviar um novo pagamento.
                    </p>
                </b-alert>
                <slot name="controles"></slot>
                <app-tabela
                    idTabela="tblPagamentos"
                    :itens="pagamentos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <pagamento-inserir
                            :pagamentosServicos="pagamentosServicos"
                            :contrato="contrato"
                            @detalharPagamento="
                                $emit('detalhar-pagamento', $event)
                            "
                        ></pagamento-inserir>
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="protocolo" slot-scope="data">
                        {{ data.protocolo }}
                        <span v-if="data.prioritario"
                            ><br /><app-status status="PRIORITÁRIO"></app-status
                        ></span>
                        <span v-if="data.especial"
                            ><br />
                            <app-status status="ESPECIAL"></app-status>
                        </span>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="acoes" v-bind="data"></slot>
                    </template>
                    <template slot="valorTotal" slot-scope="data">{{
                        data.valorTotal | currency
                    }}</template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import PagamentoInserir from './PagamentoInserir'
import { pagamentoStatus } from './PagamentoStatus'
import PagamentoTimeLine from './PagamentoTimeLine2'

export default {
    props: {
        titulo: {
            type: String,
            default: () => 'PAGAMENTOS SGTEC'
        },

        pagamentos: {
            type: Array,
            default: () => []
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },

        showFornecedor: {
            type: Boolean,
            default: true
        },

        contrato: {
            type: String
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'protocolo',
                    label: 'Protocolo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'contrato',
                    label: 'Contrato',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'qtdComprometimentos',
                    label: 'Serviços',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Anexos',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                }
            ],
            itensPorPagina: 0
        }
    },
    methods: {},

    created() {
        if (!this.showFornecedor) {
            this.campos.splice(2, 1)
        }
    },

    computed: {
        temPagamentoCriado() {
            if (this.pagamentos && this.pagamentos.length > 0) {
                return this.pagamentos.some((pagamento) => {
                    return pagamento.status == pagamentoStatus.CRIADO
                })
            }
            return false
        },

        mostrarQuadroAvisoPagamentoCriado() {
            return !this.showFornecedor && this.temPagamentoCriado
        }
    },

    watch: {},

    components: {
        PagamentoInserir,
        PagamentoTimeLine
    }
}
</script>
